import { alpha } from "@mui/material/styles";

// Drop-in replacement for the `hex-to-rgba` npm package (GPL-3.0).
// Accepts a hex color with or without the leading `#` (as the original
// library did) and an optional opacity; returns a CSS `rgba(...)` string.
// Delegates to MUI's `alpha()` which is already a project dependency.
export default function hexToRgba(color, opacity = 1) {
  if (typeof color !== "string") return color;
  const trimmed = color.trim();
  const normalized = /^[0-9a-fA-F]{3,8}$/.test(trimmed)
    ? `#${trimmed}`
    : trimmed;
  return alpha(normalized, opacity);
}
